import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setToken } from "../../utils/auth";

const API = process.env.REACT_APP_API_URL || window.location.origin;
export default function AdminLogin() {
    const nav = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr("");

        const r = await fetch(`${API}/api/auth/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username, password }),
        });

        const data = await r.json();
        if (!r.ok) {
            setErr(data?.error || "Giriş başarısız");
            return;
        }

        setToken(data.token);
        nav("/admin/products");
    };

    return (
        <div className="container" style={{ padding: "40px 0" }}>
            <div className="adminCard">
                <h2 className="adminTitle">Admin Girişi</h2>
                <form onSubmit={onSubmit} className="adminForm">
                    <input
                        className="adminInput"
                        placeholder="Kullanıcı adı"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <input
                        className="adminInput"
                        type="password"
                        placeholder="Şifre"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {err ? <div className="adminError">{err}</div> : null}
                    <button className="adminBtn" type="submit">Giriş Yap</button>
                </form>
            </div>
        </div>
    );
}